import request from '@/utils/request'
let baseURL = '/uc';

//通用查询用户信息接口
export function getUserInfo(data) {
  return request({
    url: '/api/app/v2/user/getUserByUserInfo',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
inviteCode (string, optional): 邀请码，此字段不为空的时候以此查询 ,
mobilePhone (string, optional): 手机号 ,
openId (string, optional): openid ,
userName (string, optional): 用户名
}
* */



// 更新用户资料
export function updateUser(data) {
  return request({
    url: '/api/auth/v1/user/profile',
    method: 'post',
    baseURL,
    data
  })
}
/*
 {
address (string, optional): 联系地址 ,
avatar (string, optional): 头像 ,
birthday (string, optional): 出生日期 ,
city (string, optional): 市 ,
county (string, optional): 区 ,
email (string, optional): 邮箱 ,
idcard (string, optional): 身份证 ,
name (string, optional): 姓名 ,
nation (string, optional): 国家 ,
nativePlace (string, optional): 籍贯 ,
nickname (string, optional): 昵称 ,
openid (string, optional): 对外公开的ID ,
password (string, optional): 密码 ,
phone (string, optional): 电话 ,
province (string, optional): 省 ,
sex (integer, optional): 性别，0:女,1:男,2:保密 ,
sign (string, optional): 个性签名 ,
username (string, optional): 用户名
}
**/


// 关注或取消关注
export function doFocous(data) {
  return request({
    url: '/api/focus/v1/doFocous',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
focusUserOpenid (string): 被关注用户openid ,
userOpenid (string): 用户openid
}
* */


// 获取某用户所有关注过的人的详细信息
export function getFocusedUserInfoByUserOpenid(params) {
  return request({
    url: '/api/focus/v1/getFocusedUserInfoByUserOpenid',
    method: 'post',
    baseURL,
    params
  })
}
/*
{
userOpenid (string): 用户openid
}
* */